import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const [form, setForm] = useState({ first_name: '', last_name: '', username: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { register, googleLogin } = useAuth();
  const navigate = useNavigate();

  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success('Account created! Please login.');
      navigate('/login');
    } catch (err) {
      const msg = err.response?.data;
      toast.error(typeof msg === 'string' ? msg : Object.values(msg || {}).flat().join(', ') || 'Registration failed');
    }
    setLoading(false);
  };

  const handleGoogle = async (credentialResponse) => {
    try {
      await googleLogin(credentialResponse.credential);
      toast.success('Welcome!');
      navigate('/');
    } catch {
      toast.error('Google sign-up failed');
    }
  };

  const input = { width: '100%', padding: '12px', border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box' };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 400, padding: 40, border: '1px solid #eee', boxSizing: 'border-box' }}>
        <h2 style={{ fontSize: 22, fontWeight: 300, letterSpacing: 1, textAlign: 'center', marginBottom: 32 }}>Create Account</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <input placeholder="First Name" value={form.first_name} onChange={e => set('first_name', e.target.value)} style={{ padding: '12px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }} required />
          <input placeholder="Last Name" value={form.last_name} onChange={e => set('last_name', e.target.value)} style={{ padding: '12px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }} required />
        </div>
        <input placeholder="Username" value={form.username} onChange={e => set('username', e.target.value)} style={input} required />
        <input type="email" placeholder="Email" value={form.email} onChange={e => set('email', e.target.value)} style={input} required />
        <input type="password" placeholder="Password" value={form.password} onChange={e => set('password', e.target.value)} style={input} required />
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: '12px', background: '#1a1a1a', color: '#fff', border: 'none', letterSpacing: 2, textTransform: 'uppercase', fontSize: 13, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
          {loading ? 'Creating...' : 'Register'}
        </button>
        <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
          <div style={{ flex: 1, height: 1, background: '#ddd' }} />
          <span style={{ padding: '0 12px', fontSize: 12, color: '#999' }}>OR</span>
          <div style={{ flex: 1, height: 1, background: '#ddd' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin onSuccess={handleGoogle} onError={() => toast.error('Google sign-up failed')} text="signup_with" />
        </div>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#666' }}>
          Already have an account? <Link to="/login" style={{ color: '#1a1a1a' }}>Login</Link>
        </p>
      </form>
    </div>
  );
}
